"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var elog = require("../../elog");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("../../tracker");
var sanitized_render_1 = require("../../components/sanitized_render");
var ADDITIONAL_HTML_TAGS = Object.freeze([
    'h2',
    'iframe',
    'img',
]);
var COMPONENT_NAME = 'MarkdownSection';
var MarkdownSectionHTML = /** @class */ (function (_super) {
    tslib_1.__extends(MarkdownSectionHTML, _super);
    function MarkdownSectionHTML() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkdownSectionHTML.prototype.htmlContent = function () {
        return this.props.htmlContent || this.props.contentHtml;
    };
    MarkdownSectionHTML.prototype.render = function () {
        try {
            if (!this.htmlContent())
                return null;
            return (React.createElement(sanitized_render_1.default, { className: "markdown-section", html: this.htmlContent(), htmlTag: "div", allowedTags: sanitized_render_1.ALLOWED_TAGS.concat(ADDITIONAL_HTML_TAGS), allowedAttributes: sanitized_render_1.ALLOWED_ATTRIBUTES.concat(['style']), id: this.props.jumplinkSlug }));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    MarkdownSectionHTML = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.MARKDOWN_TYPE,
                eventType: tracker_1.VIEW,
                context: {
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                },
            };
        }, { dispatchOnMount: true })
    ], MarkdownSectionHTML);
    return MarkdownSectionHTML;
}(React.Component));
exports.default = MarkdownSectionHTML;
//# sourceMappingURL=markdown_section_html.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/markdown_section_html.js
// module id = ISWB
// module chunks = 0 2 6 20